module.exports = __webpack_public_path__ + "static/media/S2N12-5.785b675c.svg";